import {Directive, ElementRef, HostListener, Renderer2, AfterViewInit, inject} from '@angular/core';

@Directive({
  selector: '[appParallax]'
})
export class ParallaxDirective implements AfterViewInit {
  private readonly renderer: Renderer2 = inject(Renderer2);
  private readonly el: ElementRef = inject(ElementRef);
  private initialTop: number = 0;

  ngAfterViewInit() {
    this.initialTop = this.el.nativeElement.getBoundingClientRect().top;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const offset = (windowHeight / 2 - rect.top - rect.height / 2) * 0.3;
    this.renderer.setStyle(this.el.nativeElement, 'transform', `translateY(${offset}px)`);
  }
}
